import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/AboutSection";
import ExhibitionsTeaser from "@/components/sections/ExhibitionsTeaser";
import CurrentlyOnView from "@/components/sections/CurrentlyOnView";
import StatsSection from "@/components/sections/StatsSection";
import HistorySection from "@/components/sections/HistorySection";
import Testimonials from "@/components/sections/Testimonials";
import Newsletter from "@/components/sections/Newsletter";
import ShopTeaser from "@/components/sections/ShopTeaser";
import ContactStrip from "@/components/sections/ContactStrip";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Hero />
      <AboutSection />
      <ExhibitionsTeaser />
      <CurrentlyOnView />
      <StatsSection />
      <HistorySection />
      <Testimonials />
      <Newsletter />
      <ShopTeaser />
      <ContactStrip />
    </div>
  );
}
